import React from 'react';

type IconProps = {
  size?: number;
  title?: string;
  style?: React.CSSProperties;
};

const OfficeFileIconBase: React.FC<{
  color: string;
  letter: string;
  title: string;
  size?: number;
  style?: React.CSSProperties;
}> = ({ color, letter, title, size = 18, style }) => {
  const w = 24;
  const h = 24;
  const bandY = 16.5;
  const bandH = 3;
  const fontSize = 11; // visually balanced for 24x24
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${w} ${h}`}
      role="img"
      aria-label={title}
      style={style}
    >
      <title>{title}</title>
      {/* Page background */}
      <path d="M6 2h8l6 6v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" fill="#F6F8FA" stroke="#D0D7DE" />
      {/* Folded corner */}
      <path d="M14 2v6h6" fill="#E9EEF3" />
      {/* Bottom band */}
      <rect x="4" y={bandY} width="16" height={bandH} rx="1" fill={color} />
      {/* Center Letter */}
      <text
        x="12"
        y="13"
        textAnchor="middle"
        fontFamily="system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
        fontSize={fontSize}
        fontWeight={700}
        fill={color}
        dominantBaseline="central"
      >
        {letter}
      </text>
    </svg>
  );
};

export const WordFileIcon: React.FC<IconProps> = ({ size = 18, title = 'Word document', style }) => (
  <OfficeFileIconBase color="#2B579A" letter="W" title={title} size={size} style={style} />
);

export const ExcelFileIcon: React.FC<IconProps> = ({ size = 18, title = 'Excel spreadsheet', style }) => (
  <OfficeFileIconBase color="#217346" letter="X" title={title} size={size} style={style} />
);

export const PowerPointFileIcon: React.FC<IconProps> = ({ size = 18, title = 'PowerPoint presentation', style }) => (
  <OfficeFileIconBase color="#D24726" letter="P" title={title} size={size} style={style} />
);

export default WordFileIcon;

